(function iife() {
	"use strict";

	angular.
	module("dx.webapp.onlineResources").
	component("dxOnlineResourceEntry", {
		templateUrl: "tmpl/online-resources/online-resource-entry-component.html",
		controller: "DxOnlineResourceEntryController",
		controllerAs: "vm",
		bindings: {
			onlineResource: "<",
			hideRemoveButton: "<",
			removeOnlineResource: "&",
			addOrEditOnlineResource: "&",
			openResourceInTab: "<",
		},
	});
}());
